<template>
	<el-card class="aui-card--fill">
		<div class="mod-sys__position">
			<!-- 搜索栏 -->
			<el-form label-position="top" :inline="true" :model="queryParams">
			  <el-row>
			    <el-col :span="5">
			      <el-form-item label="名称">
			        <el-input v-model="queryParams.classifyName" placeholder="名称" clearable></el-input>
			      </el-form-item>
			    </el-col>
			    <el-col :span="5">
			      <el-form-item label="字典值">
			        <el-input v-model="queryParams.classifyValue" placeholder="字典值" clearable></el-input>
			      </el-form-item>
			    </el-col>
			    <el-col :span="4" :offset="10">
			      <el-col :span="24">
			        <el-button style="margin-bottom: 7px" class="M-search" @click="handleQuery" type="primary">查询</el-button>
			      </el-col>
			      <el-col :span="24">
			        <el-button class="el-back M-search M-margin-l" @click="resetQuery" type="info">重置</el-button>
			      </el-col>
			    </el-col>
			  </el-row>
			  <div class="btn-left">
			    <el-button type="primary" @click="handleAdd">新增</el-button>
			  </div>
			</el-form>
			
			<!-- 表格 -->
			<el-table v-loading="loading" :data="classifyList" border style="width: 100%;">
				<el-table-column prop="classifyName"
				                 label="名称"
				                 align="center"></el-table-column>
				<el-table-column prop="classifyValue"
				                 label="字典值"
				                 header-align="center"
				                 align="center"></el-table-column>
				<el-table-column prop="classifySort"
				                 label="排序"
				                 header-align="center"
				                 align="center"></el-table-column>
				<el-table-column prop="createTime"
				                 label="创建时间"
				                 header-align="center"
				                 align="center"></el-table-column>
				<el-table-column prop="classifyStatus"
				                 label="状态"
				                 header-align="center"
				                 align="center">
								 <template slot-scope="scope">
									 <el-switch
									   style="display: block"
									   v-model="scope.row.classifyStatus"
									   active-color="#13ce66"
									   inactive-color="#ff4949"
									   active-text="启用"
									   inactive-text="禁用"
									   active-value="1"
									   inactive-value="0"
									   @change="classifyStatusSwitchChange(scope.row)">
									 </el-switch>
								 </template>
								 </el-table-column>
				<el-table-column fixed="right"
				                 align="center"
				                 width="100"
				                 label="操作">
				  <template slot-scope="scope">
				    <el-dropdown trigger="click"placement="bottom">
				      <span class="el-dropdown-link">
						  操作<em class="el-icon-caret-bottom el-icon--right"></em>
				      </span>
				      <el-dropdown-menu slot="dropdown">
				        <el-dropdown-item @click.native="handleUpdate(scope.row)">修改</el-dropdown-item>
						<!-- <el-dropdown-item v-if="!ids.includes(scope.row.id)" @click.native="handleDelete(scope.row)" :loading="bottomD">删除</el-dropdown-item> -->
				      </el-dropdown-menu>
				    </el-dropdown>
				  </template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination :current-page="queryParams.page"
			               :page-sizes="[10, 20, 50, 100]"
			               :page-size="queryParams.limit"
			               :total="total"
			               layout="total, sizes, prev, pager, next, jumper"
			               @size-change="pageSizeChangeHandle"
			               @current-change="pageCurrentChangeHandle">
			</el-pagination>
		</div>
		<!-- 添加或修改【请填写功能名称】对话框 -->
		<el-dialog append-to-body :title="title" :visible.sync="open" width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="form" :model="form" :rules="rules" label-width="80px">
				<el-row class="form-row">
					<el-col>
						<el-form-item label="字典名称" prop="classifyName">
						  <el-input v-model="form.classifyName" placeholder="请输入字典名称" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="form-row">
					<el-col>
						<el-form-item label="字典值" prop="classifyValue">
						  <el-input v-model="form.classifyValue" placeholder="请输入字典值" type="Number"/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="form-row">
					<el-col>
						<el-form-item label="课程管理">
							<el-select v-model="form.roleId" clearable filterable placeholder="请输入或选择您要绑定的角色">
								<el-option v-for="item in options" :key="item.roleId" :label="item.roleName" :value="item.roleId">
								</el-option>
							</el-select>
						</el-form-item>	
						<el-tooltip placement="bottom-start" effect="light" class="bottom">
							<div slot="content">
								<p>请选择对应的【组内课程管理员】，拥有此角色的用户，进行课程编辑时，只能操作此组内的数据。如：机电组内课程管理员，创建课程时，只能创建机电组的课程。</p>
							</div>
							<em class="el-icon-question" style="color: #1C69D3"></em>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="form-row">
					<el-col>
						<el-form-item label="辅导管理">
							<el-select v-model="form.tutorRoleId" clearable filterable placeholder="请输入或选择您要绑定的角色">
								<el-option v-for="item in options" :key="item.roleId" :label="item.roleName" :value="item.roleId">
								</el-option>
							</el-select>
						</el-form-item>
						<el-tooltip placement="bottom-start" effect="light" class="bottom">
							<div slot="content">
								<p>请选择对应的【组内辅导管理员】，拥有此角色的用户，使用辅导模块功能时，只能操作此组内的数据。如：机电组内辅导管理员，创建辅导时，只能创建机电组的辅导。</p>
							</div>
							<em class="el-icon-question" style="color: #1C69D3"></em>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="form-row">
					<el-col>
						<el-form-item label="排序" prop="classifySort">
						  <el-input-number v-model="form.classifySort" placeholder="请输入排序" :min="0" :precision="0"/>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<template slot="footer">
			  <el-button type="button" class="buttonqx" @click="cancel">返回</el-button>
			  <el-button type="button" class="buttomqr el-button--primary" @click="submitForm" :loading="bottomLoading">保存</el-button>
			</template>
		</el-dialog>
	</el-card>
</template>
<script>
	export default {
		name: "Classify",
		data() {
			return {
				options: [],
				bottomD: false,
				bottomLoading: false,
				// 查询参数
				queryParams: {
				  page: 1,
				  limit: 10,
				  classifyName: null,
				  classifyValue: null
				},
				// 遮罩层
				loading: true,
				// 表格数据
				classifyList: [],
				title: null,
				open: false,
				// 表单参数
				form: {},
				// 表单校验
				rules: {
				  classifyName: [
				    { required: true, message: "字典名称不能为空", trigger: "blur" }
				  ],
				  classifyValue: [
				    { required: true, message: "字典值不能为空", trigger: "blur"}
				  ],
				  classifySort: [
				    { required: true, message: "排序不能为空", trigger: "blur" }
				  ]
				},
				// 总条数
				total: 0,
				ids: [1,2,3,4,5,6,7],
			};
		},
		created() {
		  this.getList();
		},
		methods: {
			selectAllRolePullDown(){
				this.$request.get("/sys/commClassify/selectAllRolePullDown").then((res, data) => {
					this.options = res
				})
			},
			classifyStatusSwitchChange(classify) {
				var statusName = '启用成功';
				if(classify.classifyStatus=='0') {
					statusName = '禁用成功';
				}
				this.$request.put("/sys/commClassify/update",classify).then((res, total, code, data) => {
				  this.$message({
					message: statusName,
					type: 'success',
					duration: 500,
					onClose: () => {
					}
				  })
				})
			},
			getList() {
			  this.loading = true;
			  this.$request.get("/sys/commClassify/list",this.queryParams).then((res, total, code, data) => {
				  this.classifyList = res.records;
				  this.total = total;
				  this.loading = false;
			  })
			},
			/** 搜索按钮操作 */
			handleQuery() {
			  this.queryParams.page = 1;
			  this.getList();
			},
			/** 重置按钮操作 */
			resetQuery() {
			  this.queryParams.page = 1;
			  this.queryParams.limit = 10;
			  this.queryParams.classifyName = null;
			  this.queryParams.classifyValue = null;
			  this.handleQuery();
			},
			// 表单重置
			reset() {
			  this.form = {
				id: null,
			    classifyName: null,
			    classifyValue: null,
			    classifySort: null,
				dictGroupId: null,
				dictPositionGroupTypeId: null,
				resourceGroupId: null,
				jlClassifyId: null,
				groupId: null,
				jsClassifyIdTypeSix: null,
				createBy: null,
				roleId: null,
				dictClassifyId: null,
				tutorRoleId: null,
			  };
			  if(this.$refs['form']) {
				  this.$refs['form'].resetFields();
			  }
			},
			
			/** 新增按钮操作 */
			handleAdd() {
			  this.bottomLoading = false,
			  this.reset();
			  this.open = true;
			  this.title = "新增";
			  this.selectAllRolePullDown()
			},
			// 取消按钮
			cancel() {
			  this.open = false;
			  this.reset();
			},
			/** 提交按钮 */
			submitForm() {
			  this.bottomLoading = true
			  this.$refs["form"].validate(valid => {
			    if (valid) {
			      if (this.form.id != null) {
					  this.$request.put("/sys/commClassify/update",this.form).then((res, total, code, data) => {
						  if (res.code === 500) {
							  this.bottomLoading = false
						  }
						this.$message({
							message: "修改成功",
							type: 'success',
							duration: 500,
							onClose: () => {
							  this.loading = false;
							  this.open = false;
							  this.getList();
							}
						  })
					  }).catch(() => {
						  this.bottomLoading = false
					  });
			      } else {
					  this.$request.post("/sys/commClassify/add",this.form).then((res, total, code, data) => {
						  if (res.code === 500) {
							  this.bottomLoading = false
						  }  
						this.$message({
						    message: "新增成功",
						    type: 'success',
						    duration: 500,
						    onClose: () => {
						      this.open = false;
						      this.getList();
						    }
						  })
					  }).catch(() => {
						  this.bottomLoading = false
					  });
			      }
			    }
			  });
			},
			// 分页, 每页条数
			pageSizeChangeHandle(val) {
			  this.queryParams.page = 1
			  this.queryParams.limit = val
			  this.getList()
			},
			// 分页, 当前页
			pageCurrentChangeHandle(val) {
			  this.queryParams.page = val
			  this.getList()
			},
			/** 删除按钮操作 */
			handleDelete(row) {
			  this.$confirm('是否确认删除组群名称为"' + row.classifyName + '"的数据项？').then(function() {
			  }).then(() => {
				
				  this.$request.delete("/sys/commClassify/delete/"+row.id).then((res, total, code, data) => {
					  this.bottomD = true
					  this.$message({
					    message: "删除成功",
					    type: 'success',
					    duration: 500,
					    onClose: () => {
					      this.getList();
							this.bottomD = false
					    }
					  })
				  })
			  }).catch(() => {});
			},
			/** 修改按钮操作 */
			handleUpdate(row) {
			  this.bottomLoading = false,
			  this.reset();
			  this.$request.get("/sys/commClassify/selectCommClassifyById/"+row.id).then((res, total, code, data) => {
				  this.form = res;
				  this.open = true;
				  this.title = "修改";
			  })
			  this.selectAllRolePullDown()
			},
		}
	}
</script>

<style lang="scss" scope>
.buttonqx{
	    margin: 0px !important;
	    width: 50%;
	    background-color: #434343;
	    color: #fff;
	    border: 0px;
	    line-height: 25px;
	}
	.buttonqx:hover {
	  background: #535151 !important;
	}
	.buttomqr{
	    margin-left: 0px !important;
	    float: left !important;
	    width: 50% !important;
	    line-height: 23px;
	}
	.form-row {
		margin-bottom: 20px;
		position: relative;
	}
	.bottom{
		position: absolute;
		right:15%;
		top:8px;
	}
</style>